var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsString } from "class-validator";
export var AgentReleaseStatus;
(function (AgentReleaseStatus) {
    AgentReleaseStatus["ACTIVE"] = "ACTIVE";
    AgentReleaseStatus["DEPRECATED"] = "DEPRECATED";
    AgentReleaseStatus["WITHDRAWN"] = "WITHDRAWN";
})(AgentReleaseStatus || (AgentReleaseStatus = {}));
export class AgentReleaseDto {
}
__decorate([
    IsString()
], AgentReleaseDto.prototype, "id", void 0);
__decorate([
    IsString()
], AgentReleaseDto.prototype, "version", void 0);
__decorate([
    IsString()
], AgentReleaseDto.prototype, "semanticVersion", void 0);
__decorate([
    IsBoolean()
], AgentReleaseDto.prototype, "minimumVersion", void 0);
__decorate([
    IsString()
], AgentReleaseDto.prototype, "status", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], AgentReleaseDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], AgentReleaseDto.prototype, "updatedAt", void 0);
export class AgentReleaseInput {
}
__decorate([
    IsString()
], AgentReleaseInput.prototype, "version", void 0);
__decorate([
    IsString()
], AgentReleaseInput.prototype, "semanticVersion", void 0);
__decorate([
    IsBoolean()
], AgentReleaseInput.prototype, "minimumVersion", void 0);
__decorate([
    IsString()
], AgentReleaseInput.prototype, "status", void 0);
